import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useClientCompanyRegistrationContext } from '../client/companyRegistration/context/ClientCompanyRegistrationContext';

const POST_LOGIN_FLAG = 'afterLoginRedirect'; // sessionStorage-Key

export default function AdminLoginRedirect() {
    const { isAdmin, userInfo, isCompanyRegistrationDataFetching } = useClientCompanyRegistrationContext();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (isCompanyRegistrationDataFetching) {
            return;
        }
        if (!userInfo) {
            return;
        }

        // only redirect after login
        const cameFromLogin = sessionStorage.getItem(POST_LOGIN_FLAG) === '1';

        if (pathname !== '/') {
            if (cameFromLogin) {
                sessionStorage.removeItem(POST_LOGIN_FLAG);
            }
            return;
        }

        if (cameFromLogin && isAdmin && (pathname === '/' || pathname === '')) {
            sessionStorage.removeItem(POST_LOGIN_FLAG);
            navigate('/admin', { replace: true });
        }
    }, [isAdmin, userInfo, isCompanyRegistrationDataFetching, pathname, search, navigate]);

    return null;
}
